import { render, staticRenderFns } from "./humanStatistical.vue?vue&type=template&id=e1d4cc52&"
import script from "./humanStatistical.vue?vue&type=script&lang=js&"
export * from "./humanStatistical.vue?vue&type=script&lang=js&"
import style0 from "./humanStatistical.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports